import React from 'react'
// import { RxDownload } from "react-icons/rx";


const CompanyInfo = ({ data }) => {

    return (
        <div className='bg-[#F3F3F3] p-4 rounded-lg m-2'>
            <div className=''>
                <div className='flex justify-between place-items-center'>
                    <h3 className="font-medium text-[#0B0910CC]/80 outfit400">Company</h3>
                </div>
                <p className="text-[#0B0910] outfit500 text-wrap break-words">{data?.name || `Orbit Xpay pvt ltd`}</p>
                <p className=" text-[#0B0910] outfit500 text-wrap break-words">{data?.addressLine1 || "-"}</p>
                <p className=" text-[#0B0910] outfit500 text-wrap break-words">{data?.city || '-'}, {data?.region || '-'}</p>
                <p className=" text-[#0B0910] outfit500 text-wrap break-words">{data?.country?.name || '-'}, {data?.zipCode || '-'}</p>
            </div>
        </div>
    )
}

export default CompanyInfo